export function shouldCommitSeek({
  wasActive,
  active,
}: {
  wasActive: boolean;
  active: boolean;
}): boolean {
  return wasActive && !active;
}
